// eslint-disable-next-line wandb/no-deprecated-imports
import {uniq} from 'lodash';
import React, {useContext, useMemo} from 'react';
// eslint-disable-next-line wandb/no-deprecated-imports
import {Tab} from 'semantic-ui-react';

import {RunQueryContext} from '../../../state/runs/context';
import * as RunHelpers from '../../../util/runhelpers';
import {useKeyInfoQueryContext} from '../../MultiRunWorkspace/KeyInfoQueryContext';
import {PanelExpressionOptions} from '../../PanelExpressionOptions';
import {usePanelConfigContext} from '../PanelConfigContext';
import {RunsLinePlotConfig} from '../types';
import {getXAxisChoices, getYAxisChoices} from '../utils';

type EditExpressionsTabProps = {
  updateConfig: (config: Partial<RunsLinePlotConfig>) => void;
  config: RunsLinePlotConfig;
};

export const EditExpressionsTab = (props: EditExpressionsTabProps) => {
  const {xAxis} = usePanelConfigContext();
  const {
    keyInfoQuery: {historyKeyInfo: keyInfo},
  } = useKeyInfoQueryContext();
  const keyTypes = useMemo(
    function makeKeyTypes() {
      return RunHelpers.keyTypes(keyInfo.keys);
    },
    [keyInfo]
  );
  const runsContext = useContext(RunQueryContext);

  const [xAxisChoices, yAxisChoices] = useMemo(
    function memoXAndYChoices() {
      return [
        getXAxisChoices({
          configMetrics: props.config.metrics ?? [],
          configXAxis: xAxis,
          keyInfo,
          keyTypes,
        }),
        getYAxisChoices({
          configMetrics: props.config.metrics ?? [],
          configXAxis: xAxis,
          keyInfo,
          keyTypes,
          runsContext,
        }),
      ];
    },
    [keyInfo, props.config.metrics, xAxis, keyTypes, runsContext]
  );

  return (
    <Tab.Pane as="div" className="form-grid">
      <PanelExpressionOptions
        availableExpressionVarNames={uniq([...xAxisChoices, ...yAxisChoices])}
        config={props.config}
        exampleIdentifier={props.config.metrics?.[0] || 'x'}
        type={'lines'}
        updateConfig={props.updateConfig}
      />
    </Tab.Pane>
  );
};
